import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  dismissNotification as apiDismiss,
  getNotificationCounts as apiGetCounts,
  getNotifications as apiGetNotifications,
  markAllNotificationsRead as apiMarkAllRead,
  markNotificationRead as apiMarkRead,
  markNotificationUnread as apiMarkUnread,
  type ListNotificationsParams,
} from '@services/api/notification.api'
import type {
  Notification,
  NotificationCounts,
} from '@dataTypes/notification.types'

export const fetchNotifications = createAsyncThunk<
  Notification[],
  ListNotificationsParams | undefined
>('notification/fetchNotifications', async (params) => {
  return apiGetNotifications(params ?? {})
})

export const fetchNotificationCounts = createAsyncThunk<
  NotificationCounts,
  { date_from?: string; date_to?: string; patient_id?: string } | undefined
>('notification/fetchNotificationCounts', async (params) => {
  return apiGetCounts(params)
})

export const markNotificationReadThunk = createAsyncThunk<string, string>(
  'notification/markRead',
  async (id) => {
    await apiMarkRead(id)
    return id
  },
)

export const markNotificationUnreadThunk = createAsyncThunk<string, string>(
  'notification/markUnread',
  async (id) => {
    await apiMarkUnread(id)
    return id
  },
)

export const dismissNotificationThunk = createAsyncThunk<string, string>(
  'notification/dismiss',
  async (id) => {
    await apiDismiss(id)
    return id
  },
)

export const markAllNotificationsReadThunk = createAsyncThunk<
  { updated: number },
  void
>('notification/markAllRead', async () => {
  const result = await apiMarkAllRead()
  return result
})
